import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ArticleModule } from '@modules/article/article.module';
import { CardModule } from '@modules/card/card.module';
import { SharedModule } from '@modules/shared/shared.module';

import { ArticlePageComponent } from './article-page.component';
import { ArticleRoutingModule } from './article-routing.module';

@NgModule({
  imports: [CommonModule, ArticleRoutingModule, ArticleModule, SharedModule, CardModule, ArticlePageComponent],
})
export class ArticlePageModule {}
